export const STORAGE_KEY = 'flomni'

export enum Provider {
  MEMORY = 'MEMORY',
  COOKIE = 'COOKIE',
  LOCAL_STORAGE = 'LOCAL_STORAGE',
  SESSION_STORAGE = 'SESSION_STORAGE'
}
